export const brandsRoutes = [
  {
    name: 'brands',
    path: '/brands',
    component: () => import('@/modules/brands/views/BrandsView.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  },
  {
    name: 'brand',
    path: '/brands/:brandId',
    component: () => import('@/modules/brands/views/BrandView.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  }
]
